import React, { useId } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import HTMLReactParser from "html-react-parser";
import {
  Box,
  Button,
  Heading,
  Separator,
  Text,
  Tooltip,
} from "@radix-ui/themes";
import { Package } from "employer/types";

import { InfoIcon } from "shared/icons";

import "./plan-card.css";

export function PackageCard({ pkg }: { pkg: Package }) {
  const { t } = useTranslation("global");
  const id = useId();
  const price = Intl.NumberFormat("uk-UA", {
    style: "currency",
    currency: "UAH",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
    currencyDisplay: "narrowSymbol",
  }).format(pkg.amount);

  return (
    <Box className="plan-card">
      <Heading as="h4" className="plan-name__heading">
        {pkg.plan_name}
      </Heading>

      <Heading
        as="h2"
        color="red"
        weight="bold"
        size="8"
        className="plan-price__heading"
      >
        {price}
      </Heading>

      <Box mt="4" mb="1">
        <Text color="gray">
          {
            {
              Months: `${pkg.plan_type} ${t("month", { count: pkg.plan_type })}`,
              Years: `${pkg.plan_type} рік`,
            }[pkg.plan_type_value]
          }
        </Text>
      </Box>

      <Button className="order-plan-trigger" asChild size="4" radius="small">
        <Link to="/user/employerlogin">ЗАМОВИТИ ПАКЕТ ПОСЛУГ</Link>
      </Button>

      <Separator size="4" mt="4" mb="6" color="gray"></Separator>

      <Box>
        <ul className="plan__feature-list">
          {pkg.features.map((f, idx) => (
            <li key={id + idx} className="plan__feature-list-item">
              <Text color="green" className="feature-check-icon"></Text>
              {HTMLReactParser(f.outer)}
              <Tooltip content={<Text>{HTMLReactParser(f.inner)}</Text>}>
                <Text color="blue" highContrast>
                  <InfoIcon width={20} height={20} />
                </Text>
              </Tooltip>
            </li>
          ))}
        </ul>
      </Box>
    </Box>
  );
}
